import { useEffect, useState } from 'react';
import PageHeader from '../pageHeader/pageheader';
import { Form, Card, Tabs, Table } from 'antd';
import { API } from '../../config/api';
import { POST } from '../../utils/apicalls';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const { TabPane } = Tabs;

function TotalPaymentDetails() {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10000);
    const [data, setData] = useState<any>([]);
    const [internData, setInternData] = useState<any>([]);
    const [meta, setMeta] = useState<any>({});
    const [profit, setProfit] = useState<number>(0);
    const [internProfit, setInternProfit] = useState<number>(0);
    const [loss, setLoss] = useState<number>(0);
    const [selectedMonth, setSelectedMonth] = useState<string>("");
    const [selectedYear, setSelectedYear] = useState<string>("");
    const [monthlyData, setMonthlyData] = useState<any[]>([]);
    const [categoryData, setCategoryData] = useState<any[]>([]);

    // Colors for charts
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#FF6B6B'];

    useEffect(() => {
        fetchSalary();
    }, [selectedMonth, selectedYear, page, pageSize]);

    useEffect(() => {
        fetchIntern(page, pageSize);
    }, [page, pageSize, selectedMonth, selectedYear]);

    // Calculate total values including internship data
    useEffect(() => {
        calculateTotals();
    }, [data, internData]);

    const calculateTotals = () => {
        // Calculate total profit from regular payments
        const totalProfit = data.reduce(
            (acc: number, item: any) => acc + (parseFloat(item.IN_Amount) || 0),
            0
        );

        // Calculate total profit from internships
        const totalInternProfit = internData.reduce(
            (acc: number, item: any) => acc + (parseFloat(item.PayementAmount) || 0),
            0
        );

        // Calculate total loss
        const totalLoss = data.reduce(
            (acc: number, item: any) => acc + (parseFloat(item.OUT_Amount) || 0),
            0
        );

        setProfit(totalProfit);
        setInternProfit(totalInternProfit);
        setLoss(totalLoss);

        // Update charts with combined data
        // generateMonthlyChartData(data, internData);
        generateCategoryChartData(data, internData);
    };

    const fetchSalary = async () => {
        try {
            setIsLoading(true);
            const obj = {
                query: form.getFieldValue("query") || "",
                page: page,
                take: pageSize,
                month: selectedMonth || undefined,
                year: selectedYear || undefined,
            };

            const url = API.LIST_SALARY_DETAILS;
            const response: any = await POST(url, obj);

            if (response?.data) {
                let filteredData = response.data;

                // Filter by month if selected
                if (selectedMonth) {
                    const monthNum = parseInt(selectedMonth);
                    filteredData = filteredData.filter((item: any) => {
                        const date = new Date(item.date);
                        return date.getMonth() + 1 === monthNum;
                    });
                }

                // Filter by year if selected
                if (selectedYear) {
                    const yearNum = parseInt(selectedYear);
                    filteredData = filteredData.filter((item: any) => {
                        const date = new Date(item.date);
                        return date.getFullYear() === yearNum;
                    });
                }

                setData(filteredData);
                setMeta(response.meta || {});
            } else {
                setData([]);
                setMeta({});
            }
        } catch (error) {
            console.error("Error fetching salary details:", error);
            setData([]);
            setMeta({});
        } finally {
            setIsLoading(false);
        }
    };

    const fetchIntern = async (page: any, take: any) => {
        try {
            setIsLoading(true);
            let obj = {
                query: form.getFieldValue("query"),
                page: page,
                take: take,
                month: selectedMonth || undefined,
                year: selectedYear || undefined,
            };
            const url = API.LIST_INTERNSHIP_STUDENTS_DETAILS;
            const response: any = await POST(url, obj);

            if (response?.data) {
                let filteredData = response.data;

                // Filter by month if selected
                if (selectedMonth) {
                    const monthNum = parseInt(selectedMonth);
                    filteredData = filteredData.filter((item: any) => {
                        const date = new Date(item.createdAt || item.createdAt);
                        return date.getMonth() + 1 === monthNum;
                    });
                }

                // Filter by year if selected
                if (selectedYear) {
                    const yearNum = parseInt(selectedYear);
                    filteredData = filteredData.filter((item: any) => {
                        const date = new Date(item.createdAt || item.createdAt);
                        return date.getFullYear() === yearNum;
                    });
                }

                setInternData(filteredData);
            } else {
                setInternData([]);
            }
        } catch (error) {
            console.log("Error fetching internship details:", error);
            setInternData([]);
        } finally {
            setIsLoading(false);
        }
    };

    // const generateMonthlyChartData = (paymentData: any[], internData: any[]) => {
    //     // Group data by month
    //     const months: any = {};

    //     // Process payment data
    //     paymentData.forEach((item) => {
    //         const date = new Date(item.createdAt);
    //         const monthYear = `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;

    //         if (!months[monthYear]) {
    //             months[monthYear] = {
    //                 month: monthYear,
    //                 profit: 0,
    //                 internProfit: 0,
    //                 loss: 0,
    //                 net: 0,
    //                 date: date // Store date for proper sorting
    //             };
    //         }

    //         months[monthYear].profit += parseFloat(item.IN_Amount) || 0;
    //         months[monthYear].loss += parseFloat(item.OUT_Amount) || 0;
    //     });

    //     // Process internship data
    //     internData.forEach((item) => {
    //         const date = new Date(item.createdAt || item.createdAt);
    //         const monthYear = `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;

    //         if (!months[monthYear]) {
    //             months[monthYear] = {
    //                 month: monthYear,
    //                 profit: 0,
    //                 internProfit: 0,
    //                 loss: 0,
    //                 net: 0,
    //                 date: date // Store date for proper sorting
    //             };
    //         }

    //         months[monthYear].internProfit += parseFloat(item.amount) || 0;
    //     });

    //     // Calculate net values
    //     Object.keys(months).forEach((key) => {
    //         months[key].totalProfit = months[key].profit + months[key].internProfit;
    //         months[key].net = months[key].totalProfit - months[key].loss;
    //     });

    //     // Convert to array and sort by date
    //     const monthlyData = Object.values(months).sort((a: any, b: any) => a.date - b.date);
    //     setMonthlyData(monthlyData);
    // };

    const generateCategoryChartData = (paymentData: any[], internData: any[]) => {
        // Group data by category
        const categories: any = {};

        // Process payment data
        paymentData.forEach((item) => {
            const category = item.category || 'Other';

            if (!categories[category]) {
                categories[category] = {
                    name: category[0].toUpperCase() + category.slice(1), // Capitalize first letter
                    income: 0,
                    expense: 0,
                    count: 0
                };
            }

            categories[category].income += parseFloat(item.IN_Amount) || 0;
            categories[category].expense += parseFloat(item.OUT_Amount) || 0;
            categories[category].count += 1;
        });

        // Add internship as a separate category
        if (!categories['internship']) {
            categories['internship'] = {
                name: 'Internship',
                income: 0,
                expense: 0,
                count: 0
            };
        }

        // Process internship data
        internData.forEach((item) => {
            categories['internship'].income += parseFloat(item.PayementAmount) || 0;
            categories['internship'].count += 1;
        });

        // Convert to array
        setCategoryData(Object.values(categories));
    };

    const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMonth(e.target.value);
        setPage(1);
    };

    const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedYear(e.target.value);
        setPage(1);
    };

    const formatDate = (dateString: string) => {
        try {
            return new Date(dateString).toLocaleDateString();
        } catch (error) {
            return 'Invalid date';
        }
    };

    // Table columns for profit entries
    const profitColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (text: string) => formatDate(text)
        },
        {
            title: 'Amount',
            dataIndex: 'IN_Amount',
            key: 'amount',
            render: (text: string) => `₹${parseFloat(text).toFixed(2)}`
        },
        {
            title: 'Client',
            dataIndex: 'client',
            key: 'client',
            render: (client: any) => client?.name || 'N/A'
        },
        {
            title: 'Method',
            dataIndex: 'method',
            key: 'method'
        }
    ];

    // Table columns for internship entries
    const internColumns = [
        {
            title: 'Payment Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text: string, record: any) => formatDate(text || record.createdAt)
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text: string) => `₹${parseFloat(text).toFixed(2)}`
        },
        {
            title: 'Student Name',
            dataIndex: 'name',
            key: 'name',
            render: (text: string) => text || 'N/A'
        },
        {
            title: 'Course',
            dataIndex: 'course',
            key: 'course'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status'
        }
    ];

    // Table columns for expense entries
    const expenseColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (text: string) => formatDate(text)
        },
        {
            title: 'Amount',
            dataIndex: 'OUT_Amount',
            key: 'amount',
            render: (text: string) => `₹${parseFloat(text).toFixed(2)}`
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (text: string) => text[0].toUpperCase() + text.slice(1)
        },
        {
            title: 'Employee',
            dataIndex: 'empid',
            key: 'employee',
            render: (empid: any) => empid?.fullName || 'N/A'
        },
        {
            title: 'Method',
            dataIndex: 'method',
            key: 'method'
        }
    ];

    // Data for summary pie chart
    const summaryData = [
        { name: 'Regular Income', value: profit },
        { name: 'Internship Income', value: internProfit },
        { name: 'Total Expense', value: loss }
    ];

    const totalIncome = profit + internProfit;

    return (
        <div className="total-payment-container">
            <PageHeader />

            <div className="payment-content">
                <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>Total Payments Dashboard</h2>

                {/* Summary Cards */}
                <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                    <Card title="Regular Income" style={{ flex: 1, backgroundColor: '#e6f7ff', borderColor: '#1890ff' }}>
                        <h2 style={{ color: '#0088FE', fontSize: '24px' }}>₹{profit.toFixed(2)}</h2>
                    </Card>
                    <Card title="Internship Income" style={{ flex: 1, backgroundColor: '#e6fffb', borderColor: '#13c2c2' }}>
                        <h2 style={{ color: '#00C49F', fontSize: '24px' }}>₹{internProfit.toFixed(2)}</h2>
                    </Card>
                    <Card title="Total Expense" style={{ flex: 1, backgroundColor: '#fff1f0', borderColor: '#ff4d4f' }}>
                        <h2 style={{ color: '#FF8042', fontSize: '24px' }}>₹{loss.toFixed(2)}</h2>
                    </Card>
                    <Card title="Net Balance" style={{ flex: 1, backgroundColor: '#f6ffed', borderColor: '#52c41a' }}>
                        <h2 style={{ color: totalIncome > loss ? '#00C49F' : '#FF6B6B', fontSize: '24px' }}>₹{(totalIncome - loss).toFixed(2)}</h2>
                    </Card>
                </div>

                {/* Filters */}
                <Card title="Filter Options" style={{ marginBottom: '20px' }}>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <div>
                            <label>Month: </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{ padding: '8px', borderRadius: '4px', marginLeft: '8px' }}
                            >
                                <option value="">All</option>
                                {Array.from({ length: 12 }, (_, i) => (
                                    <option key={i + 1} value={String(i + 1)}>
                                        {new Date(0, i).toLocaleString("default", { month: "long" })}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Year: </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{ padding: '8px', borderRadius: '4px', marginLeft: '8px' }}
                            >
                                <option value="">All</option>
                                {Array.from({ length: 10 }, (_, i) => {
                                    const year = String(new Date().getFullYear() - i);
                                    return (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                </Card>

                {isLoading ? (
                    <div>Loading...</div>
                ) : (
                    <Tabs defaultActiveKey="1" type="card">
                        <TabPane tab="Dashboard" key="1">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                {/* Summary Pie Chart */}
                                <Card title="Income vs Expense Breakdown" style={{ marginBottom: '20px' }}>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <PieChart>
                                            <Pie
                                                data={summaryData}
                                                cx="50%"
                                                cy="50%"
                                                labelLine={false}
                                                outerRadius={100}
                                                fill="#8884d8"
                                                dataKey="value"
                                                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                            >
                                                {summaryData.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                ))}
                                            </Pie>
                                            <Tooltip formatter={(value) => `₹${parseFloat(value as string).toFixed(2)}`} />
                                            <Legend />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </Card>

                                {/* Monthly Trend Chart */}
                                {/* <Card title="Monthly Financial Trend" style={{ marginBottom: '20px' }}>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <LineChart data={monthlyData}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="month" />
                                            <YAxis />
                                            <Tooltip formatter={(value) => `₹${parseFloat(value as string).toFixed(2)}`} />
                                            <Legend />
                                            <Line type="monotone" dataKey="profit" stroke="#0088FE" name="Regular Income" strokeWidth={2} />
                                            <Line type="monotone" dataKey="internProfit" stroke="#00C49F" name="Internship Income" strokeWidth={2} />
                                            <Line type="monotone" dataKey="loss" stroke="#FF8042" name="Expense" strokeWidth={2} />
                                            <Line type="monotone" dataKey="net" stroke="#8884D8" name="Net" strokeWidth={2} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </Card> */}

                                {/* Category Analysis */}
                                <Card title="Category Analysis" style={{ marginBottom: '20px' }}>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart data={categoryData}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip formatter={(value) => `₹${parseFloat(value as string).toFixed(2)}`} />
                                            <Legend />
                                            <Bar dataKey="income" fill="#0088FE" name="Income" />
                                            <Bar dataKey="expense" fill="#FF8042" name="Expense" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Card>
                            </div>
                        </TabPane>

                        <TabPane tab="Regular Income" key="2">
                            <Table
                                dataSource={data.filter((item: any) => item.category === "payments")}
                                columns={profitColumns}
                                rowKey="id"
                                pagination={{ pageSize: 10 }}
                            />
                        </TabPane>

                        <TabPane tab="Internship Income" key="3">
                            <Table
                                dataSource={internData}
                                columns={internColumns}
                                rowKey="id"
                                pagination={{ pageSize: 10 }}
                            />
                        </TabPane>

                        <TabPane tab="Expense Details" key="4">
                            <Table
                                dataSource={data.filter((item: any) => item.category !== "payments")}
                                columns={expenseColumns}
                                rowKey="id"
                                pagination={{ pageSize: 10 }}
                            />
                        </TabPane>

                        <TabPane tab="List View" key="5">
                            <div>
                                <h3>Regular Income Entries:</h3>
                                {data.filter((item: any) => item.category === "payments").length > 0 ? (
                                    <ul>
                                        {data
                                            .filter((item: any) => item.category === "payments")
                                            .map((item: any) => (
                                                <li key={item.id}>
                                                    <span>Amount: ₹{item.IN_Amount}</span>
                                                    <span> - Date: {formatDate(item.date)}</span>
                                                    <span> - Client: {item.client?.name || 'N/A'}</span>
                                                </li>
                                            ))}
                                    </ul>
                                ) : (
                                    <p>No regular income entries found.</p>
                                )}
                            </div>

                            <div>
                                <h3>Internship Income Entries:</h3>
                                {internData.length > 0 ? (
                                    <ul>
                                        {internData.map((item: any) => (
                                            <li key={item.id}>
                                                <span>Amount: ₹{item.amount}</span>
                                                <span> - Date: {formatDate(item.createdAt || item.createdAt)}</span>
                                                <span> - Student: {item.name || 'N/A'}</span>
                                                <span> - Course: {item.course || 'N/A'}</span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>No internship income entries found.</p>
                                )}
                            </div>

                            <div>
                                <h3>Expense Entries:</h3>
                                {data.filter((item: any) => item.category !== "payments").length > 0 ? (
                                    <ul>
                                        {data
                                            .filter((item: any) => item.category !== "payments")
                                            .map((item: any) => (
                                                <li key={item.id}>
                                                    <span>Amount: ₹{item.OUT_Amount}</span>
                                                    <span> - Date: {formatDate(item.date)}</span>
                                                    <span> - Category: {item.category}</span>
                                                    {item.empid && <span> - Employee: {item.empid.fullName}</span>}
                                                </li>
                                            ))}
                                    </ul>
                                ) : (
                                    <p>No expense entries found.</p>
                                )}
                            </div>
                        </TabPane>
                    </Tabs>
                )}
            </div>
        </div>
    );
}

export default TotalPaymentDetails;